import type { ParamMatcher } from '@sveltejs/kit';

/**
 * Subdomains can contain letters, 0-9 and - (but only in the middle of the string)
 * // https://stackoverflow.com/a/7933253/6311961
 */
export const match = ((param) => {
    return /^[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?$/.test(param);
}) satisfies ParamMatcher;
